import { createReducer } from '@reduxjs/toolkit'

import actions from './actions'

const initialState = {
  loading: false,
  page: 1,
  pageSize: 20,
  sortBy: 'id',
  sortOrder: 'desc',
  filters: {},
  data: {
    count: 0,
    rows: []
  }
}

const generalReducers = {
  updateSettings: (state, action) => {
    return {
      ...state,
      ...action.payload
    }
  },
  clearFilters: state => {
    state.filters = {}
    state.sortBy = initialState.sortBy
    state.sortOrder = initialState.sortOrder
  },
  fetchStart: state => {
    state.loading = true
  },
  successLoad: (state, action) => {
    state.data.count = action.payload.count
    state.data.rows = action.payload.rows
    state.loading = false
  },
  failedLoad: state => {
    state.loading = false
  }
}

const RequestsReducers = createReducer(initialState, builder => {
  builder
    .addCase(actions.fetch.type, generalReducers.fetchStart)
    .addCase(actions.successLoad.type, generalReducers.successLoad)
    .addCase(actions.failedLoad.type, generalReducers.failedLoad)
    .addCase(actions.updateSettings.type, generalReducers.updateSettings)
    .addCase(actions.clearFilters.type, generalReducers.clearFilters)
})

export default RequestsReducers
